import { render, staticRenderFns } from "./VuesticTreeNode.vue?vue&type=template&id=3bc6c4d8"
import script from "./VuesticTreeNode.vue?vue&type=script&lang=js"
export * from "./VuesticTreeNode.vue?vue&type=script&lang=js"
import style0 from "./VuesticTreeNode.vue?vue&type=style&index=0&id=3bc6c4d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports